import { Component } from '@theme/component';

class VintageSzafaInstallGuide extends Component {
  #platform = /Android/i.test(navigator.userAgent) ? 'android' : 'iphone';
  #index = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  selectIphone() { this.#select('iphone'); }
  selectAndroid() { this.#select('android'); }

  #select(platform) {
    this.#platform = platform;
    this.#index = 0;
    this.#render();
  }

  get #steps() {
    return (this.refs.steps ?? []).filter(step => step.dataset.guideDevice === this.#platform);
  }

  previous() {
    this.#index = Math.max(0, this.#index - 1);
    this.#render(true);
  }

  next() {
    if (this.#index === this.#steps.length - 1) {
      this.closest('dialog')?.close();
      return;
    }
    this.#index += 1;
    this.#render(true);
  }

  #render(focus = false) {
    const steps = this.#steps;
    if (!steps.length) return;
    this.dataset.platform = this.#platform;
    this.dataset.step = String(this.#index);
    for (const step of this.refs.steps ?? []) step.hidden = step !== steps[this.#index];
    for (const button of this.querySelectorAll('[data-guide-platform]')) {
      button.setAttribute('aria-pressed', String(button.dataset.guidePlatform === this.#platform));
    }
    for (const [index, dot] of Array.from(this.querySelectorAll('[data-guide-dot]')).entries()) {
      dot.hidden = index >= steps.length;
      dot.classList.toggle('is-active', index <= this.#index);
    }
    this.refs.progress.textContent = this.dataset.progress.replace('__CURRENT__', this.#index + 1).replace('__TOTAL__', steps.length);
    this.refs.previous.disabled = this.#index === 0;
    this.refs.next.textContent = this.#index === steps.length - 1 ? this.dataset.finish : this.dataset.next;
    this.dispatchEvent(new CustomEvent('vs:pwa-guide-change', { bubbles: true }));
    if (focus) steps[this.#index].querySelector('h3')?.focus({ preventScroll: true });
  }
}

if (!customElements.get('vs-install-guide')) customElements.define('vs-install-guide', VintageSzafaInstallGuide);
